/**
 * Created by andrey on 12.07.16.
 */

import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.css'
import './datepicker.css'


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/styles/datepicker/index.ts